import { useCallback } from 'react';
import { api } from 'src/assets/static/ApiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

interface DeleteAttachmentRequest {
  ids: number[];
}
const useDeleteDocumentApi = (id: number, isInvoice: boolean) => {
  const call = useCallback(
    async (params?: DeleteAttachmentRequest) => {
      try {
        const res = await axiosInstance.post(
          isInvoice ? api.deleteAttachmentOfInvoiceIdFn(id) : api.deleteAttachmentOfReceiptIdFn(id),
          params?.ids
        );
        return res;
      } catch (error) {
        throw new Error(error);
      }
    },
    [id, isInvoice]
  );

  const { execute, isLoading } = useAsync(call, false);

  return { deleteAttachment: execute, isLoading };
};

export default useDeleteDocumentApi;
